import moment from 'moment-timezone';
import { theme } from '../../theme';

export const SIDER_WIDTH = Number(theme.layout.sider.width);
export const THEME_LAYOUT = 'dark';
export const PER_PAGE_OTHER = 10;
export const PER_PAGE_DEFAULT = 15;
export const PER_PAGE_20 = 20;
export const PER_PAGE_100 = 100;
export const FORMAT_DATE = 'YYYY-MM-DD';
export const MAX_LENGTH_DESCRIPTION = 2000;
export const ZONE = 'America/Los_Angeles';
export const DEFAULT_TIME = moment('12:00', 'hh:mm P');
export const FORMAT_DATETIME_US = 'hh:mma, MMM - DD, YYYY';
export const FORMAT_DATE_US = 'MMM - DD, YYYY';
export const FORMAT_DATE_US_TIME_ZONE = 'hh:mm:ss A z, MMMM - DD, YYYY';
export const PAGE_SIZE_OPTIONS = ['15', '20', '50', '100'];
export const WIDTH_MODAL = 1024;
export const TEXT_COLOR_WHITE = '#ffffff';
export const TEXT_COLOR_BLACK = '#000000';
export const DEFAULT_BACKGROUND_OPACITY = 0;
export enum URLType {
  HOME = 'HOME',
  MFE_APP = 'MFE_APP',
  TRADE_IN = 'TRADE_IN',
  PDP = 'PDP',
  ORDER_HISTORY = 'ORDER_HISTORY',
  CHECK_OUT = 'CHECK_OUT',
  CUSTOM = 'CUSTOM',
  GRID_PAGE = 'GRID_PAGE',
}
export const getUrLEcom = (country: any) => {
  const envStage = process.env.REACT_APP_STAGE;
  let url = null;
  if (envStage === 'development') {
    if (country === 'CAN' || country === 'CA') {
      url = `https://development.taylormadegolf.ca`;
    } else {
      url = `https://development.taylormadegolf.com`;
    }
  } else if (envStage === 'staging') {
    if (country === 'CAN' || country === 'CA') {
      url = `https://staging.taylormadegolf.ca`;
    } else {
      url = `https://staging.taylormadegolf.com`;
    }
  } else if (country === 'CAN' || country === 'CA') {
    url = `https://taylormadegolf.ca`;
  } else {
    url = `https://taylormadegolf.com`;
  }

  return url;
};

export enum URL_ECOM {
  HOME = '/on/demandware.store/Sites-TMaG-Site/en_US/MyTM-OpenSession?provider=auth0&page=home&iframe=true',
  MFE_APP = '/on/demandware.store/Sites-TMaG-Site/en_US/MyTM-OpenSession?provider=auth0&page=mfeapp&iframe=true',
  TRADE_IN = '/on/demandware.store/Sites-TMaG-Site/en_US/MyTM-OpenSession?provider=auth0&page=tradein&iframe=true',
  ORDER_HISTORY = '/on/demandware.store/Sites-TMaG-Site/en_US/MyTM-OpenSession?provider=auth0&page=orders&iframe=true',
  CHECK_OUT = '/on/demandware.store/Sites-TMaG-Site/en_US/MyTM-OpenSession?provider=auth0&page=checkout&iframe=true',
}

export enum URL_ECOM_CAN {
  HOME = '/on/demandware.store/Sites-TMaG-CA-Site/en_CA/MyTM-OpenSession?provider=auth0&page=home&iframe=true',
  MFE_APP = '/on/demandware.store/Sites-TMaG-CA-Site/en_CA/MyTM-OpenSession?provider=auth0&page=mfeapp&iframe=true',
  TRADE_IN = '/on/demandware.store/Sites-TMaG-CA-Site/en_CA/MyTM-OpenSession?provider=auth0&page=tradein&iframe=true',
  ORDER_HISTORY = '/on/demandware.store/Sites-TMaG-CA-Site/en_CA/MyTM-OpenSession?provider=auth0&page=orders&iframe=true',
  CHECK_OUT = '/on/demandware.store/Sites-TMaG-CA-Site/en_CA/MyTM-OpenSession?provider=auth0&page=checkout&iframe=true',
}

export const getFuLLUrlEcom = (type: string, country: string) => {
  let ctaNewLink = '';
  let subUrl = '';
  let blockLink = false;
  switch (type) {
    case URLType.HOME:
      subUrl = country === 'CAN' || country === 'CA' ? URL_ECOM_CAN.HOME : URL_ECOM.HOME;
      ctaNewLink = `${getUrLEcom(country)}${subUrl}`;
      blockLink = true;
      break;
    case URLType.MFE_APP:
      subUrl = country === 'CAN' || country === 'CA' ? URL_ECOM_CAN.MFE_APP : URL_ECOM.MFE_APP;
      ctaNewLink = `${getUrLEcom(country)}${subUrl}`;
      blockLink = true;
      break;
    case URLType.TRADE_IN:
      subUrl = country === 'CAN' || country === 'CA' ? URL_ECOM_CAN.TRADE_IN : URL_ECOM.TRADE_IN;
      ctaNewLink = `${getUrLEcom(country)}${subUrl}`;
      blockLink = true;
      break;
    case URLType.ORDER_HISTORY:
      subUrl = country === 'CAN' || country === 'CA' ? URL_ECOM_CAN.ORDER_HISTORY : URL_ECOM.ORDER_HISTORY;
      ctaNewLink = `${getUrLEcom(country)}${subUrl}`;
      blockLink = true;
      break;
    case URLType.CHECK_OUT:
      subUrl = country === 'CAN' || country === 'CA' ? URL_ECOM_CAN.CHECK_OUT : URL_ECOM.CHECK_OUT;
      ctaNewLink = `${getUrLEcom(country)}${subUrl}`;
      blockLink = true;
      break;
    default:
      blockLink = false;
      break;
  }

  return { ctaNewLink, blockLink };
};

export const URLTypeList = [
  {
    text: 'HOME',
    value: URLType.HOME,
  },
  {
    text: 'MFEapp',
    value: URLType.MFE_APP,
  },
  {
    text: 'Tradein',
    value: URLType.TRADE_IN,
  },
  {
    text: 'PDP',
    value: URLType.PDP,
  },
  {
    text: 'Order history',
    value: URLType.ORDER_HISTORY,
  },
  {
    text: 'Checkout',
    value: URLType.CHECK_OUT,
  },
  {
    text: 'Grid Page',
    value: URLType.GRID_PAGE,
  },
  {
    text: 'Custom',
    value: URLType.CUSTOM,
  },
];

export const URLTypePromotionList = [
  {
    text: 'PDP',
    value: URLType.PDP,
  },
  {
    text: 'Grid Page',
    value: URLType.GRID_PAGE,
  },
  {
    text: 'Custom',
    value: URLType.CUSTOM,
  },
];
